export default __webpack_public_path__ + "static/media/together.877f35d6.png";